import React, {useState, useEffect} from 'react';
import {Link} from 'gatsby';
import useMenu from '../../query/useMenu';
import BtBurger from '../BtBurger';

import styles from './styles.module.css';

const Menu = () => {
  const [open, toggleOpen] = useState(false);
  const {headerMenu} = useMenu();
  useEffect(() => {
    if (open === true) {
      document.body.style.position = 'fixed';
    } else {
      document.body.style.position = 'initial';
    }
  }, [open]);
  return (
    <nav className={`${styles.header__nav} ${open ? styles.open : ''}`}>
      <ul>
        {headerMenu.nodes.map(({navigation}) =>
          navigation.map(({page, label}) => (
            <li key={page.id}>
              <Link onClick={state => toggleOpen(false)} to={page.fields.slug}>
                {label || page.frontmatter.title}
              </Link>
            </li>
          )),
        )}
        <li className={styles.go_cart}>
          <button
            onClick={state => toggleOpen(false)}
            className="snipcart-checkout"
          >
            Voir le panier
          </button>
        </li>
      </ul>
      <div className={styles.btn}>
        <BtBurger isOpen={open} onClick={state => toggleOpen(state)} />
      </div>
    </nav>
  );
};

export default Menu;
